export default __webpack_public_path__ + "c21849c8f196972062da12fb9d9f5500.jpg";